import { render, staticRenderFns } from "./AskMoveMandate.vue?vue&type=template&id=fc75568e&"
import script from "./AskMoveMandate.vue?vue&type=script&lang=js&"
export * from "./AskMoveMandate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports